import React from "react";

class Video extends React.Component {
  render() {
    return (
      <section id="video">
        <div className="container">
          <div className="col-md-12">
            <div className="section-title">
              <h2>I’m the Best Coder! Challenge 2019 Highlights</h2>
            </div>
            <div className="video-wrapper">
              <iframe title="Video" className="video" src="https://www.youtube.com/embed/-xBP_cf_aTs" frameBorder="0" allow="fullscreen"></iframe>
            </div>
          </div>
        </div>
      </section>
    );
  }

}

export default Video;